import { DependsOnIfEnum, DependsOnThenEnum, IDependsOn } from '@cak-legacy/generation-schema-core';
import { ISimpleForm } from '../../form/interface/SimpleForm/ISimpleForm';
import { PredefinedFieldType } from '../../form/interface/SimpleForm/PredefinedFieldType';
import { RegelingOptions } from '../../form/interface/SimpleForm/RegelingOptions';
import { Step } from '../../form/interface/SimpleForm/Step';

const dependsOnVoorWie: IDependsOn[] = [
  {
    property: 'contactgegevens.voorwie',
    if: DependsOnIfEnum.IsEqualToValue,
    value: 'voormijzelf',
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true,
  },
  {
    property: 'contactgegevens.voorwie',
    if: DependsOnIfEnum.IsNotGiven,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true,
  },
];

export class SimpleFormBuilder {
  private name = 'DummyForm';
  private steps: Step[] = [];

  constructor() {
    this.steps.push({
      name: 'Inleiding Klachtformulier',
      isIntroduction: true,
    });
    this.steps.push({
      name: 'Contact gegevens',
      Sections: [
        {
          name: 'contactgegevens',
          fields: {
            voorletters: {
              predefinedFieldType: PredefinedFieldType.voorletters,
              isRequired: true,
            },
            achternaam: {
              predefinedFieldType: PredefinedFieldType.achternaam,
              isRequired: true,
              autoComplete: true,
            },
            geboortenaam: {
              predefinedFieldType: PredefinedFieldType.geboortenaam,
            },
            email: {
              predefinedFieldType: PredefinedFieldType.email,
              isRequired: true,
              autoComplete: true,
            },
            telefoonnummer: {
              predefinedFieldType: PredefinedFieldType.telefoonnummer,
              autoComplete: true,
            },
            voorwie: {
              type: 'radio',
              options: [
                {
                  label: 'VoorMijzelf',
                  value: 'voormijzelf',
                },
                {
                  label: 'VoorIemandAnders',
                  value: 'voorander',
                },
              ],
              ui: {
                flexDirection: 'column',
              },
              validate: {
                isRequired: {
                  value: true,
                },
              },
            },
          },
        },
        {
          name: 'voorWieGegevens',
          fields: {
            voorWieGegevensVoorletters: {
              predefinedFieldType: PredefinedFieldType.voorletters,
              isRequired: true,
            },
            voorWieGegevensAchternaam: {
              predefinedFieldType: PredefinedFieldType.achternaam,
              isRequired: true,
            },
            voorWieGegevensGeboortenaam: {
              predefinedFieldType: PredefinedFieldType.geboortenaam,
            },
          },
          dependsOn: dependsOnVoorWie,
        },
      ],
    });

    this.steps.push({
      name: 'Klacht omschrijving',
      Sections: [
        {
          name: 'klachtomschrijving',
          fields: {
            regeling: {
              predefinedFieldType: PredefinedFieldType.regeling,
              isRequired: true,
              regelingOptions: [
                RegelingOptions.BeschermdWonen,
                RegelingOptions.MedicijnenMeeOpReis,
                RegelingOptions.Gemoedsbezwaarden,
                RegelingOptions.Onverzekerden,
                RegelingOptions.BetalingsachterstandZorgpremie,
                RegelingOptions.Wlz,
                RegelingOptions.WmoAT,
                RegelingOptions.Buitenland,
                RegelingOptions.Onbekend,
              ],
            },
            klantId: {
              predefinedFieldType: PredefinedFieldType.cakKenmerk,
            },
            klacht: {
              type: 'textarea',
              validate: {
                isRequired: {
                  value: true,
                },
                maxLength: {
                  value: 1000,
                },
              },
              ui: {
                flexDirection: 'column',
              },
              label: 'OmschrijfUwKlacht',
            },
            bijlage: {
              predefinedFieldType: PredefinedFieldType.bijlage,
            },
          },
        },
      ],
    });
  }

  withStep(step: Step): SimpleFormBuilder {
    this.steps.push(step);
    return this;
  }

  withName(name: string): SimpleFormBuilder {
    this.name = name;
    return this;
  }

  build(): ISimpleForm {
    return {
      name: this.name,
      steps: [...this.steps],
    };
  }
}
